<template>
  <div class="artwork-netx-row-details mt-3 grey lighten-4">
    <div class="artwork-netx-row-header">
      <div>
        <strong>NetX images</strong>
        <span v-if="!loading" class="caption grey--text ml-2">
          {{ assets.length }} image{{ assets.length === 1 ? '' : 's' }}
        </span>
        <span v-if="metadataDifferenceCount" class="caption amber--text text--darken-3 ml-2">
          {{ metadataDifferenceCount }} image{{ metadataDifferenceCount === 1 ? '' : 's' }} differ
        </span>
      </div>
      <div class="artwork-netx-row-actions">
        <span v-if="syncMessage" class="caption" :class="syncMessageClass">{{ syncMessage }}</span>
        <v-btn v-if="error" small flat @click="requestAssets(true)">
          <v-icon small left>refresh</v-icon>Retry
        </v-btn>
        <v-btn
          v-if="canSyncNetx"
          small
          color="primary"
          :loading="syncActive"
          :disabled="syncDisabled || syncActive || selectionBusy || !artwork.accession_number"
          @click="$emit('sync', { artworkId: artwork.id })"
        >
          <v-icon small left>cloud_download</v-icon>Sync from NetX
        </v-btn>
      </div>
    </div>

    <v-progress-linear v-if="loading" indeterminate height="2" class="ma-0" />
    <v-alert v-else-if="error" :value="true" type="error" outline class="ma-3">
      {{ error }}
    </v-alert>
    <div v-else-if="assets.length === 0" class="artwork-netx-empty">
      No matched NetX images found for this artwork.
    </div>
    <v-container v-else grid-list-md fluid class="pa-3">
      <v-layout row wrap>
        <v-flex v-for="asset in assets" :key="asset.id" xs12 sm6 md4 lg3>
          <netx-asset-card
            :artwork="artwork"
            :asset="asset"
            :disabled="selectionBusy"
            @select="$emit('select', $event)"
            @retry="requestAssets(true)"
            @notice="$emit('notice', $event)"
            @edit="editPhoto"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <artwork-photo-drawer
      v-model="photoDrawerOpen"
      :artwork="artwork"
      :photo-id="photoDrawerPhotoId"
      @saved="photoSaved"
    />
  </div>
</template>

<script>
import NetxAssetCard from './NetxAssetCard'
import ArtworkPhotoDrawer from './ArtworkPhotoDrawer'
import { canSyncNetx } from '@/utils/netxArtworkReview'

export default {
  components: { NetxAssetCard, ArtworkPhotoDrawer },
  props: {
    artwork: { type: Object, required: true },
    assets: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    syncState: { type: Object, default: () => ({}) },
    syncDisabled: { type: Boolean, default: false }
  },
  data: () => ({
    photoDrawerOpen: false,
    photoDrawerPhotoId: null
  }),
  computed: {
    canSyncNetx () {
      return canSyncNetx(this.c_user)
    },
    selectionBusy () {
      return this.assets.some(asset => asset.selection && asset.selection.active)
    },
    metadataDifferenceCount () {
      return this.assets.filter(asset => asset.artwork_photo_metadata_differs).length
    },
    syncActive () {
      return ['pending', 'running'].includes(this.syncState.status)
    },
    syncMessage () {
      if (this.syncState.status === 'completed') {
        return `Synced: ${this.syncState.assets_created || 0} new, ${this.syncState.assets_updated || 0} updated, ${this.syncState.assets_failed || 0} failed`
      }
      if (this.syncState.status === 'failed') return this.syncState.error_message || 'NetX sync failed.'
      if (this.syncState.status === 'pending') return 'NetX sync queued'
      if (this.syncState.status === 'running') return 'Syncing NetX images'
      return ''
    },
    syncMessageClass () {
      return this.syncState.status === 'failed' ? 'red--text' : 'grey--text text--darken-1'
    }
  },
  watch: {
    'artwork.id': function () {
      this.requestAssets()
    }
  },
  mounted () {
    this.requestAssets()
  },
  methods: {
    editPhoto ({ photoId }) {
      this.photoDrawerPhotoId = photoId
      this.photoDrawerOpen = true
    },
    photoSaved (result) {
      this.$emit(
        'notice',
        result.publicProcessingQueued
          ? 'Image details saved. Public image versions are processing.'
          : 'Image details saved.'
      )
      this.requestAssets(true)
    },
    requestAssets (retry) {
      this.$emit('ensure', { artworkId: this.artwork.id, retry: !!retry })
    }
  }
}
</script>

<style scoped>
.artwork-netx-row-details { border: 1px solid #deded9; }
.artwork-netx-row-header { align-items: center; background: #f0f0ec; border-bottom: 1px solid #deded9; display: flex; justify-content: space-between; min-height: 42px; padding: 7px 12px; }
.artwork-netx-row-actions { align-items: center; display: flex; gap: 8px; }
.artwork-netx-empty { color: #666; font-size: 13px; padding: 18px 12px; }
</style>



// WEBPACK FOOTER //
// src/components/artworks/ArtworkNetxRowDetails.vue